import React from 'react';

const CircleProgressBar = ({ percentage, width }: { percentage: number, width?: number }) => {
    const radius = 50;
    const strokeWidth = 18;
    const viewBoxSize = radius * 2 + strokeWidth * 2;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - percentage / 100 * circumference;

    return (
        <svg viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`} width={width ? width : '100%'}>
            <circle
                r={radius}
                cx={viewBoxSize / 2}
                cy={viewBoxSize / 2}
                fill="none"
                strokeWidth={strokeWidth}
                stroke="#a0dcba"
            />
            <circle
                r={radius}
                cx={viewBoxSize / 2}
                cy={viewBoxSize / 2}
                fill="none"
                strokeWidth={strokeWidth}
                stroke="#1db461"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
            />
            <text
                x={viewBoxSize / 2}
                y={viewBoxSize / 2}
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize="18"
                fontWeight="500"
            >
                {percentage}%
            </text>
        </svg>
    );
};

export default CircleProgressBar;
